/* eslint-disable react/prop-types */
import { h, Fragment } from 'preact';
import { useRef, useState } from 'preact/hooks';

const AddonAdder = ({ possibleOptions, dispatch }) => {
  const selectRef = useRef();
  const [addState, setAddState] = useState(false);

  const addOption = () => {
    const relevantVariant = possibleOptions.find(
      (opt) => `${opt.id}` === `${selectRef.current.value}`
    );
    setAddState(false);
    dispatch({
      type: 'ADD_AO',
      payload: relevantVariant,
    });
  };

  const checkIfValidAddon = (e) => {
    setAddState(e.currentTarget.value != 'default');
  };

  return (
    <Fragment>
      <div className="curbside_optionAdder">
        <select ref={selectRef} onChange={checkIfValidAddon}>
          <option value="default" defaultSelected>
            Add a flavour
          </option>
          {possibleOptions.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.title}
            </option>
          ))}
        </select>
        <button
          className="btn btn--secondary-accent"
          onClick={addOption}
          disabled={!addState}
        >
          {!addState ? `select a flavour` : `add flavour`}
        </button>
      </div>
    </Fragment>
  );
};

export default AddonAdder;
